.content {
  display: flex;
  padding: 5px 15px;
  flex-direction: column;
}

.item {
  align-items: center;
  border-bottom: 1px solid var(--dark-4);
  display: flex;
  gap: 10px;
  height: 48px;
}
